/**
 * Flex Component
 * Box with display: flex for flexbox layouts
 */

import React, { forwardRef } from 'react';
import { Box } from './Box';

/**
 * Flex Component
 * A Box with display="flex", supporting all flex-related style props
 * 
 * @example
 * <Flex justify="space-between" align="center" gap={4}>
 *   <Box>Item 1</Box>
 *   <Box>Item 2</Box>
 * </Flex>
 */
export const Flex = forwardRef(({
  direction,
  flexDirection,
  align,
  alignItems,
  justify,
  justifyContent,
  wrap,
  flexWrap,
  basis,
  flexBasis,
  grow,
  flexGrow,
  shrink,
  flexShrink,
  ...props
}, ref) => {
  return (
    <Box
      ref={ref}
      display="flex"
      flexDirection={direction || flexDirection}
      alignItems={align || alignItems}
      justifyContent={justify || justifyContent}
      flexWrap={wrap || flexWrap}
      flexBasis={basis || flexBasis}
      flexGrow={grow || flexGrow}
      flexShrink={shrink || flexShrink}
      {...props}
    />
  );
});

Flex.displayName = 'Flex';

export default Flex;
